export default function brandColumn() {
    return {
        name: 'brand', label: 'Brand',
        options: {
			headerAlign: 'left'
        }
    }
}